import { render, staticRenderFns } from "./RequestForQuotationTable.vue?vue&type=template&id=5e7209f5&scoped=true&"
import script from "./RequestForQuotationTable.vue?vue&type=script&lang=js&"
export * from "./RequestForQuotationTable.vue?vue&type=script&lang=js&"
import style0 from "./RequestForQuotationTable.vue?vue&type=style&index=0&id=5e7209f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7209f5",
  null
  
)

export default component.exports